import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFieldComponent } from '../../models/dynamic-field-component';
import { DynamicFormEntry } from '../../models/dynamic-form-entry';

@Component({
  selector: 'bom-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
})
export class LabelComponent implements DynamicFieldComponent {
  config: DynamicFormEntry;
  group: FormGroup;
}
